import "./index.scss";
import { Button, ButtonLink } from "@wise-emotions/react-button";
import {
  GeneralSmallArrowLeft,
  GeneralSmallArrowRight,
} from "@wise-emotions/react-icons";
import { GetTranslationsObj } from "types/types";
import {
  HeaderSubmenuGroup,
  HeaderSubmenuSidebar,
  ShowAllCtaLabel,
} from "components/HeaderNew/HeaderFull/types";
import { Poly } from "components/Poly";
import { PolyAnchor } from "components/Anchor/utils";
import HeaderMenuItem from "components/HeaderNew/components/HeaderMenuItem";
import React from "react";
import cn from "classnames";

type Props = {
  groups: HeaderSubmenuGroup[];
  sidebarMenu?: HeaderSubmenuSidebar | null;
  anchorProps: PolyAnchor;
  showAllCtaLabel?: ShowAllCtaLabel;
  isMobile?: boolean;
  translations: GetTranslationsObj;
  onBlur: VoidFunction;
  onClickMobileBackCta?: VoidFunction;
};

const SubmenuDropdown = ({
  groups,
  sidebarMenu,
  anchorProps,
  showAllCtaLabel,
  isMobile,
  translations,
  onBlur,
  onClickMobileBackCta,
}: Props) => {
  const haveGroupsTitles = groups.some(({ title }) => title);

  return (
    <div className="submenu-dropdown">
      {sidebarMenu && !isMobile && (
        <div className="submenu-dropdown__sidebar">
          <div className="submenu-dropdown__sidebar__title">
            {sidebarMenu.title}
          </div>
          <div className="submenu-dropdown__sidebar__description">
            {sidebarMenu.text}
          </div>
          {(sidebarMenu.ctaImage?.href || sidebarMenu.ctaImage?.to) && (
            <Poly
              className="submenu-dropdown__sidebar__image"
              {...sidebarMenu.ctaImage}
            >
              {sidebarMenu.image && sidebarMenu.image}
            </Poly>
          )}
        </div>
      )}
      <div className="submenu-dropdown__right-content">
        {showAllCtaLabel?.labelMobile && (
          <div className="submenu-dropdown__mobile-cta">
            <ButtonLink
              variant="leftIcon"
              Icon={GeneralSmallArrowLeft}
              text={translations.back}
              onClick={onClickMobileBackCta}
            />
            <Button size="sm" variant="default" {...anchorProps}>
              {showAllCtaLabel.labelMobile}
            </Button>
          </div>
        )}
        <ul className="submenu-dropdown__groups">
          {groups.map(({ title, items }, groupIndex) => (
            <li>
              {haveGroupsTitles && (
                <div
                  className={cn("submenu-dropdown__groups__title", {
                    "submenu-dropdown__groups__title--empty": !title,
                  })}
                >
                  {title}
                </div>
              )}
              <ul className="submenu-dropdown__groups__list">
                {items.map((item, itemsIndex) => (
                  <li className="submenu-dropdown__groups__item">
                    <HeaderMenuItem
                      key={item.label}
                      onBlur={
                        groupIndex === groups.length - 1 &&
                        itemsIndex === items.length - 1 &&
                        !showAllCtaLabel?.labelDesktop
                          ? onBlur
                          : undefined
                      }
                      {...item}
                    />
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
        {!isMobile && showAllCtaLabel?.labelDesktop && (
          <div className="submenu-dropdown__show-all-cta">
            <ButtonLink
              onBlur={onBlur}
              text={showAllCtaLabel.labelDesktop}
              variant="rightIcon"
              Icon={GeneralSmallArrowRight}
              {...anchorProps}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default SubmenuDropdown;
